var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFooter = function SvgFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 5v14.02c0 1.1-.9 1.98-2 1.98H3c-1.1 0-2-.88-2-1.98V5c0-1.1.9-2 2-2h18c1.1 0 2 .9 2 2m-3-.02H4c-.55 0-1 .45-1 1v12.05c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V5.98c0-.55-.45-1-1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1z"
  })));
};
export default SvgFooter;